'use client';

import { useEffect, useState } from 'react';
import { useConfigure, useSearchBox } from 'react-instantsearch';
import { useSearchParams } from 'next/navigation';

export default function JobTitleSearch() {
  useConfigure({ restrictSearchableAttributes: ['title'] });
  const { query, refine } = useSearchBox();
  const [value, setValue] = useState(query);
  const params = useSearchParams();

  useEffect(() => {
    const initial = params.get('title');
    if (initial) {
      const decoded = decodeURIComponent(initial);
      setValue(decoded);
      refine(decoded);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setValue(query);
  }, [query]);

  return (
    <input
      type="text"
      value={value}
      onChange={(e) => {
        setValue(e.target.value);
        refine(e.target.value);
      }}
      placeholder="Titre"
      aria-label="Rechercher par titre"
      className="input input-bordered w-48 max-w-xs rounded-[100px] border-zinc-200 text-sm font-bold focus:outline-none"
    />
  );
}
